<div class="container-fluid">
  <div class="styles-body">
    <div class="panel-body content-body-pages">
      <!-- Header Section -->
      <div class="page-header">
        <div class="header-content">
          <div class="header-icon">
            <mat-icon>add_shopping_cart</mat-icon>
          </div>
          <div class="header-text">
            <h1
              class="page-title">{{ isAddToExistingMode ? ('AddProductToExistingFactor' | translate) : (isNewCustomerMode ? ('NewOrderRegistration' | translate) : ('PlaceOrderForCustomer' | translate)) }}
            </h1>
          </div>
        </div>
        <div class="header-actions">
          <button (click)="backToCustomer()"
                  class="back-btn">
            <mat-icon>arrow_back</mat-icon>
            <span>{{ isNewCustomerMode ? ('BackToDashboard' | translate) : ('BackToCustomer' | translate) }}</span>
          </button>
        </div>
      </div>
      <!-- Customer Information Card -->
      <div class="customer-info-card">
        <div class="card-header">
          <div class="header-icon">
            <mat-icon>person</mat-icon>
          </div>
          <div class="header-text">
            <h4>{{ 'CustomerInformation' | translate }}</h4>
            <p>{{ 'CustomerInformationForOrder' | translate }}</p>
          </div>
        </div>
        <div class="card-content">
          @if (isNewCustomerMode && !foundUser && !customerInfo.name) {
            <!-- Customer Search Form -->
            <div class="customer-search-form">
              <div class="search-section">
                <label for="mobileSearch">{{ 'CustomerMobileNumber' | translate }}:</label>
                <div class="search-input-group">
                  <input
                    (input)="checkIfChange($event)"
                    (keyup.enter)="searchUserByMobile()"
                    [(ngModel)]="mobileNumber"
                    [englishNumberOnly]="true"
                    class="mobile-input"
                    id="mobileSearch"
                    maxlength="11"
                    minlength="11"
                    mobile
                    placeholder="09123456789"
                    type="tel">
                  <button
                    (click)="searchUserByMobile()"
                    [disabled]="isSearchingUser || !mobileNumber || mobileNumber.length < 11"
                    class="search-btn">
                    @if (isSearchingUser) {
                      <mat-icon class="spinning">refresh</mat-icon>
                    } @else {
                      <mat-icon>search</mat-icon>
                    }
                    {{ 'Search' | translate }}
                  </button>
                </div>
              </div>
            </div>
            <!-- New Customer Form (shown when user not found) -->
            @if (searchedUser && !foundUser && mobileNumber.length === 11) {
              <div class="new-customer-form">
                <h5>{{ 'NewUserCompleteInformation' | translate }}:</h5>
                <div class="form-grid">
                  <div class="form-group">
                    <app-frontend-input
                      [(value)]="newCustomerInfo.firstName"
                      [required]="true"
                      placeHolder="{{ 'EnterFirstName' | translate }}"
                      title="{{ 'FirstName' | translate }}"
                      type="text">
                    </app-frontend-input>
                  </div>
                  <div class="form-group">
                    <app-frontend-input
                      [(value)]="newCustomerInfo.lastName"
                      [required]="true"
                      placeHolder="{{ 'EnterLastName' | translate }}"
                      title="{{ 'LastName' | translate }}"
                      type="text">
                    </app-frontend-input>
                  </div>
                  <div class="form-group">
                    <app-frontend-date
                      [(value)]="newCustomerInfo.birthDate"
                      [required]="false"
                      title="{{ 'BirthDate' | translate }}">
                    </app-frontend-date>
                  </div>
                </div>
                <div class="form-actions">
                  <button
                    (click)="createNewUser()"
                    class="create-user-btn">
                    <mat-icon>person_add</mat-icon>
                    {{ 'CreateNewUser' | translate }}
                  </button>
                  <button
                    (click)="resetCustomerSearch()"
                    class="reset-btn">
                    <mat-icon>refresh</mat-icon>
                    {{ 'StartOver' | translate }}
                  </button>
                </div>
              </div>
            }
          } @else if (foundUser || customerInfo.name) {
            <!-- Existing Customer Information -->
            <div class="customer-details">
              <div class="detail-item">
                <div class="detail-icon">
                  <mat-icon>person_outline</mat-icon>
                </div>
                <div class="detail-content">
                  <span class="label">{{ 'CustomerName' | translate }}</span>
                  <span class="value">{{ customerInfo.name }}</span>
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-icon">
                  <mat-icon>phone</mat-icon>
                </div>
                <div class="detail-content">
                  <span class="label">{{ 'CustomerPhone' | translate }}</span>
                  <span class="value">{{ customerInfo.phone }}</span>
                </div>
              </div>
            </div>
            @if (isNewCustomerMode) {
              <div class="customer-actions">
                <button (click)="resetCustomerSearch()"
                        class="change-customer-btn">
                  <mat-icon>person_add</mat-icon>
                  {{ 'ChangeCustomer' | translate }}
                </button>
              </div>
            }
          }
        </div>
      </div>
      @if (foundUser) {
        <div class="order-placement-container">
          <!-- Left Side - Menu Section -->
          <div class="menu-section">
            <!-- Branch Section -->
            <div class="branch-section">
              <div class="section-title">
                <mat-icon>store</mat-icon>
                <span>{{ 'SelectBranch' | translate }}</span>
              </div>
              <div class="branch-container">
                <div class="branch-grid">
                  @if (branches && branches.length > 0) {
                    @for (branch of branches; track branch.BusinessId) {
                      <div (click)="onBranchClick(branch)"
                           [ngClass]="{'selected': isBranchSelected(branch)}"
                           class="branch-item">
                        <div class="branch-icon">
                          <mat-icon>store</mat-icon>
                        </div>
                        <div class="branch-info">
                          <h4 class="branch-title">{{ branch.Title }}</h4>
                          @if (branch.Address) {
                            <p class="branch-address">{{ branch.Address }}</p>
                          }
                        </div>
                        <div class="branch-selection-indicator">
                          <img [src]="isBranchSelected(branch) ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                               alt="selection">
                        </div>
                      </div>
                    }
                  } @else {
                    <div class="no-branches">
                      <mat-icon>store</mat-icon>
                      <p>{{ 'LoadingBranches' | translate }}</p>
                    </div>
                  }
                </div>
              </div>
            </div>
            <!-- Search Section -->
            <div class="search-section">
              <div class="search-container">
                <div class="search-input-wrapper">
                  <input [class.searching]="isSearching"
                         [formControl]="searchControl"
                         [placeholder]="'ProductSearch' | translate"
                         class="search-input"
                         type="text">
                  <div class="search-icon">
                    <img alt="search"
                         height="20"
                         src="/icons/ic_search.svg"
                         width="20">
                  </div>
                  @if (searchControl.value && searchControl.value.length > 0) {
                    <button (click)="clearSearch()"
                            class="clear-search-btn"
                            type="button">
                      <img alt="clear"
                           height="20"
                           src="/icons/close-circle.svg"
                           width="20">
                    </button>
                  }
                </div>
              </div>
            </div>
            <!-- Categories and Tags Section -->
            <div *ngIf="!showSearchResults"
                 class="categories-section">
              <div class="section-title">
                <span>{{ 'Categories' | translate }}</span>
              </div>

              @if (isLoadingCategories) {
                <div class="loading-categories">
                  <div class="loading-spinner">
                    <mat-icon>refresh</mat-icon>
                  </div>
                  <p>{{ 'LoadingCategories' | translate }}</p>
                </div>
              } @else {
                <div class="categories-grid">
                  <!-- Tags -->
                  @for (tag of tags; track tag.TagId) {
                    <div (click)="onTagClick(tag)"
                         [ngClass]="{'selected': selectedTagId === tag.TagId}"
                         class="category-item">
                      <div class="category-icon">
                        <img [src]="formatImage('', tag?.Icon)"
                             alt="tag"
                             height="40"
                             width="40">
                      </div>
                      <div class="category-title">{{ tag.Title }}</div>
                      <div class="category-count">{{ tag.ServiceCount }} محصول</div>
                    </div>
                  }

                  <!-- Categories -->
                  @for (category of categories; track category.CategoryId) {
                    <div (click)="onCategoryClick(category)"
                         [ngClass]="{'selected': selectedCategoryId === category.CategoryId}"
                         class="category-item">
                      <div class="category-icon">
                        <img [src]="formatImage('', category?.Icon)"
                             alt="category"
                             height="40"
                             width="40">
                      </div>
                      <div class="category-title">{{ category.Title }}</div>
                      <div class="category-count">{{ category.ServiceCount }} محصول</div>
                    </div>
                  }
                </div>
              }
            </div>
            <!-- Products Section -->
            <div class="products-section">
              <div class="section-title">
                <span>{{ getSelectedTitle() }}</span>
                @if (products.length > 0) {
                  <span class="product-count">({{ products.length }} {{ 'Products' | translate }})</span>
                }
              </div>
              <div class="products-grid">
                @if (products.length > 0) {
                  @for (product of products; track product.ServiceId) {
                    <div class="product-card">
                      <div class="product-image">
                        <img [src]="formatImage('x', product?.Images[0])"
                             alt="product">
                      </div>
                      <div class="product-info">
                        <div class="product-header">
                          <h4 class="product-title">{{ product.Title }}</h4>
                        </div>

                        @if (product.Description) {
                          <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(product.Description)"
                             class="product-description"></p>
                        }

                        <div class="product-spacer"></div>
                        <div class="product-price-rating">
                          <div class="price-section">
                            @if (product.ServicePrices[0]?.NewPrice && product.ServicePrices[0]?.NewPrice !== product.ServicePrices[0]?.Price) {
                              <div class="price-row">
                                <span class="old-price">{{ product.ServicePrices[0]?.Price | number:'1.0-0' }}
                                  ریال</span>
                              </div>
                              <div class="price-row">
                              <span class="new-price">{{ product.ServicePrices[0]?.NewPrice | number:'1.0-0' }}
                                ریال</span>
                              </div>
                            } @else {
                              <div class="price-row">
                                <span class="price">{{ product.ServicePrices[0]?.Price | number:'1.0-0' }} ریال</span>
                              </div>
                            }
                          </div>
                          <div class="rating-section">
                            <div class="product-rating">
                              <span class="rate-text">{{ product.Rate || 0 | number:'1.1-1' }}</span>
                              <img alt="rating"
                                   height="16"
                                   src="/icons/star.svg"
                                   width="16">
                            </div>
                          </div>
                        </div>
                        <div class="product-actions">
                          <button (click)="addToOrder(product.ServicePrices[0].ServicePriceId,undefined)"
                                  class="add-to-order-btn">
                            <mat-icon>add_shopping_cart</mat-icon>
                            <span>{{ 'AddToOrder' | translate }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                } @else {
                  <div class="no-products">
                    <div class="no-products-icon">
                      <img alt="no products"
                           height="80"
                           src="/icons/empty-list.svg"
                           width="80">
                    </div>
                    <div class="no-products-content">
                      <h4>{{ 'NoProductsFound' | translate }}</h4>
                      <p>{{ 'PleaseSelectAnotherCategory' | translate }}</p>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <!-- Right Side - Order Summary -->
          <div class="order-summary-section">
            <div class="order-summary-card">
              <div class="card-header">
                <mat-icon>shopping_cart</mat-icon>
                <h4>{{ 'OrderSummary' | translate }}</h4>
              </div>
              <div class="card-content">
                @if (orderItems.length > 0) {
                  <div class="order-items">
                    @for (item of orderItems; track $index) {
                      <div class="order-item">
                        <div class="item-info">
                          <h5 class="item-title">{{ item?.ServicePrice?.Service?.Title }}</h5>
                          <p class="item-price">{{ item?.UnitPrice | number:'1.0-0' }} ریال</p>
                        </div>
                        <div class="item-controls">
                          <div class="quantity-controls">
                            <button (click)="addToOrder(item?.ServicePriceId, item?.Count - 1)"
                                    class="qty-btn">-
                            </button>
                            <span class="quantity">{{ item?.Count }}</span>
                            <button (click)="addToOrder(item?.ServicePriceId, item?.Count + 1)"
                                    class="qty-btn">+
                            </button>
                          </div>
                          <div class="item-total">
                            {{ item?.TotalPrice | number:'1.0-0' }} ریال
                          </div>
                          <button (click)="addToOrder(item?.ServicePriceId,0)"
                                  class="remove-btn">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="order-notes">
                    <label for="orderNotes">{{ 'OrderNotes' | translate }}:</label>
                    <textarea [(ngModel)]="orderNotes"
                              id="orderNotes"
                              placeholder="یادداشت سفارش..."
                              rows="3">
                   </textarea>
                  </div>
                  <!-- Checkout Section -->
                  <div class="checkout-section">
                    <h5 class="section-title">{{ 'OrderDeliveryMethod' | translate }}</h5>
                    <!-- Delivery Methods -->
                    @for (deliveryMethod of deliveryMethods; track $index) {
                      @if (deliveryMethod?.Type === 'OUTSIDE_DELIVER') {
                        <div (click)="onChangeDeliveryMethod(deliveryMethod)"
                             [ngClass]="{'selected': deliveryMethod?.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId}"
                             class="delivery-method">
                          <div class="delivery-method-content">
                            <mat-icon class="delivery-icon">local_shipping</mat-icon>
                            <div class="delivery-info">
                              <span class="delivery-title">{{ deliveryMethod?.Title | translate }}</span>
                              @if (selectedUserAddress && deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId) {
                                <span class="address-title">{{ selectedUserAddress?.Title | translate }}</span>
                                <p class="address-details">{{ selectedUserAddress?.Address | translate }}
                                  - {{ selectedUserAddress?.Detail | translate }}
                                </p>
                                <p class="recipient-info">{{ 'DeliveryRecipient' | translate }}
                                  : {{ selectedUserAddress?.RecipientFullName | translate }}
                                  - {{ selectedUserAddress?.Phone | translate }}
                                </p>
                              }
                              <div class="address-actions">
                                @if (deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId) {
                                  <button (click)="openChangeAddressClicked(deliveryMethod); $event.stopPropagation()"
                                          class="address-action-btn">
                                    {{ selectedUserAddress ? ('AddressChange' | translate) : ('AddressSelect' | translate) }}
                                  </button>
                                }
                              </div>
                            </div>
                            <img
                              [src]="deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                              class="selection-indicator">
                          </div>
                        </div>
                      } @else if (deliveryMethod.Type === 'INSIDE_DELIVER') {
                        <div (click)="onChangeDeliveryMethod(deliveryMethod)"
                             [ngClass]="{'selected': deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId}"
                             class="delivery-method">
                          <div class="delivery-method-content">
                            <mat-icon class="delivery-icon">location_on</mat-icon>
                            <div class="delivery-info">
                            <span
                              class="delivery-title">{{ deliveryMethod?.Title | translate }} @if (Config.branch.Details?.Title) {
                              ({{ Config.branch.Details.Title }})
                            }</span>
                              @if (Config.branch.Details?.Address) {
                                <p class="branch-address">{{ Config.branch.Details.Address | translate }}</p>
                              } @else {
                                <p class="branch-address-placeholder">اطلاعات شعبه در حال بارگذاری...</p>
                              }
                              @if (Config.branch.Details?.Phone) {
                                <p class="branch-phone">{{ 'Phone' | translate }}
                                  : {{ Config.branch.Details.Phone | translate }}
                                </p>
                              } @else {
                                <p class="branch-phone-placeholder">شماره تماس در حال بارگذاری...</p>
                              }
                            </div>
                            <img
                              [src]="deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                              class="selection-indicator">
                          </div>
                        </div>
                      } @else if (deliveryMethod.Type === 'INSIDE') {
                        <div (click)="onChangeDeliveryMethod(deliveryMethod)"
                             [ngClass]="{'selected': deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId}"
                             class="delivery-method">
                          <div class="delivery-method-content">
                            <mat-icon class="delivery-icon">airline_seat_recline_normal</mat-icon>
                            <div class="delivery-info">
                              <span class="delivery-title">{{ deliveryMethod?.Title | translate }}</span>
                              @if (selectedSpace) {
                                <p class="space-info">{{ 'SelectedSpace' | translate }}
                                  : {{ selectedSpace?.Title | translate }}
                                </p>
                              }
                              <div class="space-actions">
                                @if (deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId) {
                                  <button (click)="openChangeSpaceClicked(); $event.stopPropagation()"
                                          class="space-action-btn">
                                    {{ selectedSpace ? ('ChangeSpace' | translate) : ('SelectSpace' | translate) }}
                                  </button>
                                }
                              </div>
                            </div>
                            <img
                              [src]="deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                              class="selection-indicator">
                          </div>
                        </div>
                      }
                    }

                    <!-- Payment Methods -->
                    <h5 class="section-title">{{ 'paymentMethod' | translate }}</h5>
                    @if (selectedDeliveryMethod) {
                      @for (paymentMethod of paymentMethods; track $index) {
                        <div (click)="onChangePaymentMethod(paymentMethod)"
                             [ngClass]="{'selected': selectedPaymentType?.PaymentMethodId === paymentMethod.PaymentMethodId}"
                             class="payment-method">
                          <div class="payment-method-content">
                            @if (paymentMethod?.Type === 'CASH') {
                              <img alt="نقدی"
                                   class="payment-icon"
                                   height="24"
                                   src="/icons/dollar.svg"
                                   width="24">
                            } @else if (paymentMethod?.Type === 'PSP') {
                              @if (paymentMethod.Metadata?.PSP === 'SAMAN') {
                                <img alt="سامان"
                                     class="payment-icon"
                                     height="24"
                                     src="/icons/logo-saman-bank.svg"
                                     width="24">
                              } @else if (paymentMethod.Metadata?.PSP === 'ZARINPAL') {
                                <img alt="زرین‌پال"
                                     class="payment-icon"
                                     height="24"
                                     src="/icons/zarinpal.svg"
                                     width="24">
                              } @else {
                                <img alt="پرداخت"
                                     class="payment-icon"
                                     height="24"
                                     src="/icons/image-placeholder.svg"
                                     width="24">
                              }
                            } @else if (paymentMethod?.Type === 'WALLET') {
                              <img alt="کیف پول"
                                   class="payment-icon"
                                   height="24"
                                   src="/icons/wallet.svg"
                                   width="24">
                            } @else if (paymentMethod?.Type === 'CARD_TO_CARD') {
                              <img alt="کارت به کارت"
                                   class="payment-icon"
                                   height="24"
                                   src="/icons/card.svg"
                                   width="24">
                            } @else if (paymentMethod?.Type === 'POS') {
                              <img alt="کارت به کارت"
                                   class="payment-icon"
                                   height="24"
                                   src="/icons/pos.svg"
                                   width="24">
                            }
                            <div class="payment-info">
                              <span class="payment-title">{{ paymentMethod.Title | translate }}</span>
                              @if (paymentMethod?.Type === 'POS' && selectedPos) {
                                <span class="payment-title">{{ ': ' + selectedPos?.BankName }}</span>
                              }
                            </div>
                            <img
                              [src]="selectedPaymentType?.PaymentMethodId === paymentMethod.PaymentMethodId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                              class="selection-indicator">
                          </div>
                          @if (paymentMethod?.Type === 'POS' && selectedPaymentType?.PaymentMethodId === paymentMethod.PaymentMethodId) {
                            <div class="space-actions">
                              <button (click)="openChangePosClicked(paymentMethod); $event.stopPropagation()"
                                      class="space-action-btn">
                                {{ selectedPos ? ('ChangePos' | translate) : ('SelectPos' | translate) }}
                              </button>
                            </div>
                          }
                        </div>
                      }
                    } @else {
                      <div class="no-delivery-method">
                        <img alt="delivery"
                             height="40"
                             src="/icons/delivery-method.svg"
                             width="40">
                        <span>{{ 'FirstSelectDeliveryMethod' | translate }}</span>
                      </div>
                    }

                    <!-- Financial Summary -->
                    <div class="financial-summary">
                      <div class="financial-item">
                        <span>{{ 'TotalSum' | translate }}</span>
                        <p
                          class="total-amount">{{ StringUtil.numberAsCurrency(preFactor?.TotalOrderPrice ?? 0) + ' ریال' }}
                        </p>
                      </div>
                      <div class="financial-item">
                        <span>{{ 'ShippingCost' | translate }}</span>
                        @if (!selectedDeliveryMethod) {
                          <p class="delivery-price-placeholder">{{ 'DeliveryPriceAfterSelect' | translate }}</p>
                        } @else {
                          <p
                            class="delivery-price">{{ StringUtil.numberAsCurrency(preFactor?.DeliveryPrice ?? 0) + ' ریال' }}
                          </p>
                        }
                      </div>
                      <div class="financial-item">
                        <span>{{ 'ValueAddedTax' | translate }}</span>
                        <p
                          class="tax-amount">{{ StringUtil.numberAsCurrency(preFactor?.TaxPrice ?? 0) + ' ریال' }}
                        </p>
                      </div>
                      <div class="financial-item">
                        <span>{{ 'Total' | translate }}</span>
                        <p
                          class="total-amount">{{ StringUtil.numberAsCurrency(preFactor?.PayablePrice ?? 0) + ' ریال' }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <button (click)="confirmOrder()"
                          [disabled]="(!selectedPaymentType || !selectedDeliveryMethod)"
                          class="confirm-order-btn">
                    <mat-icon>check_circle</mat-icon>
                    <span>{{ isAddToExistingMode ? ('AddToFactor' | translate) : ('ConfirmOrder' | translate) }}</span>
                  </button>
                } @else {
                  <div class="empty-order">
                    <div class="empty-icon">
                      <mat-icon>shopping_cart_outline</mat-icon>
                    </div>
                    <div class="empty-content">
                      <h5>{{ 'ShoppingCartEmpty' | translate }}</h5>
                      <p>{{ 'SelectProductFromMenu' | translate }}</p>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
